/**
 * The minimum time between attempted measurements of PerformanceTiming
 */
export const DEFAULT_FLO_PERF_INTERVAL_MS = 100
